import { createAction, props } from '@ngrx/store';

/**
 * Action to set the active list id in localStorage
 */
export const setActiveList = createAction(
  '[ProductList] Set Active List',
  props<{ id: string }>(),
);

export const setActiveListSuccess = createAction(
  '[ProductList] Set Active List Success',
  props<{ id: string }>(),
);

export const setActiveListFail = createAction(
  '[ProductList] Set Active List Fail',
);

/**
 * @deprecated Unused methods
 */
export const unsetActiveList = createAction('[ProductList] Unset Active List');

/**
 * Action to load the active list id from localStorage
 */
export const loadActiveList = createAction(
  '[ProductList] Load Active List from memory',
);
